var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavoritesLabelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 24a2 2 0 01-2-2V2a2 2 0 012-2h17.487a2 2 0 011.835 1.205l4.333 10a2 2 0 010 1.59l-4.333 10A2 2 0 0119.487 24H2z",
    fill: "url(#favoritesLabelIcon_svg__paint0_linear_10508_105353)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.126 24H19l5.205-11.154a2 2 0 000-1.692L19 0h.126a2 2 0 011.813 1.154l4.666 10a2 2 0 010 1.692l-4.666 10A2 2 0 0119.126 24z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.025 12.475l1.06 1.06 4.95 4.95 6.011-6.01a3.5 3.5 0 00-4.95-4.95l-1.06 1.06-1.061-1.06a3.5 3.5 0 00-4.95 4.95zM14 12.5l-2-2-2 2 2 2 2-2z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "favoritesLabelIcon_svg__paint0_linear_10508_105353",
    x1: 13,
    y1: 23.693,
    x2: 13,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B81D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6385E"
  })))));
}

export default SvgFavoritesLabelIcon;